const messageConfig = require('@/models/messageConfig.js');
const dateJs = require('@/assets/js/date').default;

const Number_Validation = (rule, value) => {
  return parseFloat(value) !== 'NaN' && !isNaN(value);
};

module.exports = {
  paymentScheduleDetail: {
    from: [
      {
        required: true,
        message: messageConfig.getMessage('validformrequire'),
      },
      {
        message: 'Invalid Setting',
        validator(rule, value, callback, source) {
          if (new Date(value).getTime() !== source.from_correct_time) {
            return false;
          }

          return true;
        },
      },
    ],
    to: [
      {
        required: true,
        message: messageConfig.getMessage('validformrequire'),
      },
      {
        message: 'Invalid Setting',
        validator(rule, value, callback, source) {
          if (new Date(value).getTime() !== source.to_correct_time) {
            return false;
          }

          return true;
        },
      },
    ],
    mediaAmount: {
      required: true,
      message: messageConfig.getMessage('errornumber'),
      validator: Number_Validation,
    },
    productionAmount: {
      required: true,
      message: messageConfig.getMessage('errornumber'),
      validator: Number_Validation,
    },
    totalAmount: {
      required: true,
      message: messageConfig.getMessage('errornumber'),
      validator: Number_Validation,
    },
    invoiceDate: [
      {
        required: true,
        message: messageConfig.getMessage('validformrequire'),
      },
      {
        //Inv issue date不可以後於payment due date
        message: 'Invalid Setting',
        validator(rule, value, callback, source) {
          var date = new Date(value);
          var date1 = new Date(source.paymentDueDate);

          return date.getTime() <= date1.getTime();
        },
      },
    ],
    paymentDueDate: {
      required: true,
      message: messageConfig.getMessage('validformrequire'),
    },
  },
  paymentScheduleData: {
    paymentScheduleDetail_size: {
      required: true,
      message: messageConfig.getMessage('paymentdetailrequire'),
      validator: (rule, value) => {
        return value && value > 0;
      },
    },
    totalScheduleAmount: {
      type: 'number',
      message: '"Total Amount" is not eqaul to "Total Schedule Amount"',
      validator: (rule, value, callback, source) => {
        var totalAmount = parseFloat(
          source.paymentScheduleDetail
            .map((t) => parseFloat(t.totalAmount))
            .reduce((a, b) => a + b)
        );
        return value === totalAmount;
      },
    },
    scheduleMediaAmount: {
      type: 'number',
      message: '"Schedule Amount" cannot greater than "Outstanding Amount"',
      validator: (rule, value, callback, source) => {
        var outstanding = parseFloat(
          source.paymentSummary.outstandingMediaAmount
        );
        return value === outstanding;
      },
    },
    scheduleProductionAmount: {
      type: 'number',
      message: '"Schedule Amount" cannot greater than "Outstanding Amount"',
      validator: (rule, value, callback, source) => {
        var outstanding = parseFloat(
          source.paymentSummary.outstandingProductionAmount
        );
        return value === outstanding;
      },
    },
  },
};
